"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetDeadlineActionPicker = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function SetDeadlineActionPicker(props) {
    const { action, onChangeAction, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const handleChangeUnit = (0, react_1.useCallback)(v => {
        config.unit = v;
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [action, config, onChangeAction]);
    return (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: 'flex-start' },
        react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { noMargin: true, type: 'number', value: config === null || config === void 0 ? void 0 : config.duration, disabled: disabled, onBlur: t => {
                config.duration = parseInt(t);
                action.workflowActionConfig = config;
                onChangeAction(new WorkflowAction_1.default(action));
            } }),
        react_1.default.createElement(Select_1.default, { value: config === null || config === void 0 ? void 0 : config.unit, disabled: disabled, onChange: handleChangeUnit },
            react_1.default.createElement(MenuItem_1.default, { value: "hour" },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('hour'))),
            react_1.default.createElement(MenuItem_1.default, { value: "day" },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('day'))),
            react_1.default.createElement(MenuItem_1.default, { value: "month" },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('month'))))));
}
exports.SetDeadlineActionPicker = SetDeadlineActionPicker;
exports.default = SetDeadlineActionPicker;
